import ButtonToolbar from "@rio-cloud/rio-uikit/ButtonToolbar";
import Card from "@rio-cloud/rio-uikit/Card";
import Button from "@rio-cloud/rio-uikit/components/button/Button";
import { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router";

import {
    ButtonContainer,
    Container,
    TextContainer,
} from "@/components/organism/WhatIsFleetAssistant/WhatIsFleetAssistant.styles";
import { EAppRoutes } from "@/routes/routes";
import { setCurrentPage } from '@/store/about/aboutSlice';
import {setCurrentLayout} from "@/store/layout/layoutSlice";

import NewFeaturesSection from '../NewFeaturesSection/NewFeaturesSection';
import OverviewCards from '../OverviewCards/OverviewCards';
import PageNavigation from '../PageNavigation/PageNavigation';

const texts = {
  introduction: 'getStartedPage.whatIsFleetAssistant.introduction',
  expanderTitle: 'getStartedPage.expanderPanelWarning.title',
  startChatLabel: 'getStartedPage.whatIsFleetAssistant.startChatLabel',
  startChatButtonLabel: 'getStartedPage.common.startChat.label',
  learnMoreLabel: 'getStartedPage.getStartedSection.learnMore.label',
  previousLabel: 'getStartedPage.welcome.label',
  nextLabel: 'getStartedPage.howVirtualAssistantWorks.label',
};

const classes = {
  container: 'margin-top-25',
  sectionTitle: 'text-size-h3 text-bold padding-x-20',
};

const WhatIsFleetAssistant = () => {
  const dispatch = useDispatch();
  const componentTopRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleStartConversation = () => {
      dispatch(setCurrentLayout('chat'));
      navigate(EAppRoutes.CHAT);
  };

  const scrollFunction = () => {
      if (componentTopRef.current) {
          componentTopRef.current.scrollIntoView({ behavior: 'smooth' });
      }
  };

  const pageTopRef = useRef<HTMLDivElement>(null);

  const handlePreviousSection = () => dispatch(setCurrentPage('page1'));
  const handleNextSection = () => dispatch(setCurrentPage('page3'));

  useEffect(() => {
    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
      <div className={classes.container}>
          <div ref={pageTopRef} style={{position: 'absolute', top: '0'}}/>
          <div className='margin-auto margin-bottom-25'>
              <Card className='padding-x-25 padding-y-50 display-flex flex-column flex-row-sm gap-25'>
                  <img src="assets/images/hero-image.svg" alt="" width="200"/>
                  <div className='display-flex flex-wrap gap-10'>
                      <div className='flex-1-1'>
                          <p className='margin-bottom-15'>
                              <FormattedMessage id={texts.introduction}/>
                          </p>
                      </div>
                      <ButtonToolbar className='flex-1-1'>
                          <Button bsStyle={Button.PRIMARY} onClick={handleStartConversation}>
                              <FormattedMessage id={texts.startChatButtonLabel}/>
                          </Button>
                          <Button bsStyle={Button.DEFAULT} onClick={scrollFunction}>
                              <FormattedMessage id={texts.learnMoreLabel}/>
                          </Button>
                      </ButtonToolbar>
                  </div>
              </Card>
          </div>
          <OverviewCards/>
          <NewFeaturesSection/>
          <Container>
              <TextContainer ref={componentTopRef}>
                  <p>
                      <FormattedMessage id={texts.startChatLabel}/>
                  </p>
                  <ButtonContainer align="center">
                      <Button bsStyle={Button.PRIMARY} onClick={handleStartConversation}>
                          <FormattedMessage id={texts.startChatButtonLabel}/>
                      </Button>
                  </ButtonContainer>
              </TextContainer>
              <PageNavigation
                  onNext={handleNextSection}
                  onPrevious={handlePreviousSection}
                  previousLabel={texts.previousLabel}
                  nextLabel={texts.nextLabel}
              />
          </Container>
      </div>
  );
};

export default WhatIsFleetAssistant;
